










































































































































import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import "swiper/dist/css/swiper.css";
const { swiper, swiperSlide } = require("vue-awesome-swiper");

@Component({
  components: {
    HelloWorld,
    swiper,
    swiperSlide
  }
})
export default class Home extends Vue {}
